<template>
  <div>
    <vxe-grid
      ref="itemTable"
      auto-resize
      highlight-hover-row
      size="mini"
      :data="v_tableData"
      :columns="tableColumns"
      :edit-config="{ enabled: !disabled, trigger: 'click', mode: 'row' }"
      :height="tableHeight - 100"
      border
      :edit-rules="validRules"
      @edit-closed="reassign"
    >
      <template v-slot:top>
        <div class="side-frame-success">
          <span class="side-frame-text">
            {{ '渠道模板配置' }}
          </span>
          <el-divider direction="vertical" v-if="!disabled"></el-divider>
          <b-button
            class="mr-2"
            size="sm"
            variant="outline-success"
            @click="addNewsRow()"
            v-if="!disabled"
            ><i class="el-icon-plus" />{{ $l('INDEX.btn_add') || '新增' }}
          </b-button>
          <b-button
            class="mr-2"
            size="sm"
            variant="outline-danger"
            v-if="!disabled"
            @click="removeRow()"
            ><i class="el-icon-delete" />{{ $l('INDEX.btn_delete') || '删除' }}
          </b-button>
        </div>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_delete') || '删除'"
            placement="top"
            v-if="!disabled"
          >
            <i class="el-icon-delete tool-btn" @click="delRow(row)"></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:templateType="{ row }">
        <el-select
          v-model="row.templateType"
          :placeholder="'请选择模板类型'"
          style="width: 100%"
          filterable
          size="small"
          @change="(e) => templateChange(e, row)"
        >
          <el-option
            v-for="item in selectOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </template>
      <template v-slot:templateName="{ row }">
        <el-input
          v-model="row.templateName"
          readonly
          :placeholder="'请选择渠道模板'"
          size="small"
        >
          <el-button
            slot="append"
            icon="el-icon-finished"
            @click="() => openTmplateVisible(row)"
          ></el-button>
        </el-input>
      </template>

      <template v-slot:empty="{}">
        <div style="text-align: center">
          <p class="no-data mt-2">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
    <chooseTemplate
      :visible.sync="chooseTemplateVisible"
      :templateQueryParams="{ templateGroup: 'Order-Sync-Template' }"
      @confirm="(val) => templateConfirm(val)"
    />
  </div>
</template>
<script>
import tableColumns from './table-columns'
import TableAutoHeight from '@/mixins/table-auto-height'
import chooseTemplate from '../choose-template'
export default {
  mixins: [TableAutoHeight],
  props: {
    disabled: { type: Boolean, default: false },
  },
  components: { chooseTemplate },
  data() {
    return {
      v_tableData: [],
      selectOptions: [
        { label: '新建', value: 'CREATE' },
        { label: '确认', value: 'ACKNOWLEDGE' },
        { label: '发运', value: 'SHIP' },
        { label: '送达', value: 'DELIVER' },
        { label: '取消', value: 'CANCEL' },
        { label: '退款', value: 'REFUND' },
        { label: '附件变更', value: 'CHANGE_FILE' },
        { label: '库存变更', value: 'CHANGE_INV' },
        { label: '订单拉取', value: 'PULL' },
        { label: '发票', value: 'INVOICE' },
      ],
      tableColumns: tableColumns(this),
      chooseTemplateVisible: false,
      validRules: {
        templateName: [
          {
            required: true,
            message: '请选择渠道模板...',
            trigger: 'change',
          },
        ],
        v_templateType: [
          {
            required: true,
            message: '请选择模板类型...',
            trigger: 'change',
          },
        ],
      },
    }
  },
  methods: {
    async addNewsRow() {
      const $itemTable = this.$refs.itemTable
      const { row: newRow } = await $itemTable.insertAt(
        { templateCode: '', templateType: '' },
        -1
      )
      await $itemTable.setActiveCell(newRow, 'templateCode')
    },
    async delRow(row) {
      this.$refs.itemTable.remove(row)
      this.reassign()
    },
    getTableData() {
      const { fullData } = this.$refs.itemTable.getTableData()
      return fullData
    },
    async validate() {
      // 校验重复数据
      const tableData = await this.getTableData()
      if (tableData && tableData.length) {
        const keys = tableData.map((item) => `${item.templateType}`)
        const reKeys = keys.filter(
          (i) => keys.indexOf(i) !== keys.lastIndexOf(i)
        )
        if (reKeys && reKeys.length) {
          this.$message.error('存在重复的模板类型，请检查。')
          return false
        }
      } else {
        this.$message.warning('请添加渠道模板配置')
        return false
      }
      console.log('tableData', tableData)

      return !(await this.$refs.itemTable.validate(true))
    },
    async removeRow() {
      await this.$refs.itemTable.removeCheckboxRow()
      this.reassign()
    },
    reassign() {
      this.v_tableData = this.getTableData()
    },
    templateChange(e, row) {
      this.selectOptions.forEach((item) => {
        if (item.value === e) {
          row.v_templateType = item.label
        }
      })
    },
    openTmplateVisible(row) {
      this.chooseTemplateVisible = true
      this.row = row
    },
    templateConfirm(val) {
      this.row.templateName = val.templateName
      this.row.templateCode = val.templateCode
      this.chooseTemplateVisible = false
    },
  },
}
</script>
